{
  "actionbar.actions": "액션",
  "actionbar.actionsAvailable": "사용 가능한 액션",
  "actionbar.clearSelection": "선택 항목 지우기",
  "actionbar.selected": "{count, plural, =0 {선택된 항목 없음} other {#개 선택됨}}",
  "actionbar.selectedAll": "모두 선택됨",
  "actionbutton.pending": "보류 중",
  "breadcrumbs.more": "기타 항목",
  "button.pending": "보류 중",
  "calendar.invalidSelection": "선택한 {selectedCount, plural, one {일자를} other {일자를}} 사용할 수 없습니다.",
  "combobox.loading": "로드 중…",
  "combobox.loadingMore": "추가 로드 중…",
  "combobox.noResults": "결과 없음",
  "contextualhelp.help": "도움말",
  "contextualhelp.info": "정보",
  "datepicker.endTime": "종료 시간",
  "datepicker.startTime": "시작 시간",
  "datepicker.time": "시간",
  "dialog.alert": "경고",
  "dialog.dismiss": "무시",
  "dropzone.replaceMessage": "파일을 드롭하여 바꾸기",
  "inlinealert.informative": "정보",
  "inlinealert.negative": "오류",
  "inlinealert.notice": "경고",
  "inlinealert.positive": "성공",
  "label.(optional)": "(선택 사항)",
  "label.(required)": "(필수 사항)",
  "listview.loading": "로드 중…",
  "listview.loadingMore": "추가 로드 중…",
  "menu.loading": "로드 중…",
  "menu.loadingMore": "추가 로드 중…",
  "menu.moreActions": "기타 액션",
  "menu.noResults": "결과 없음",
  "menu.unavailable": "사용할 수 없음, 자세히 보려면 펼치기",
  "notificationbadge.indicatorOnly": "새로운 활동",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "로드 중…",
  "picker.loadingMore": "추가 로드 중…",
  "picker.placeholder": "선택…",
  "picker.selectedCount": "{count, plural, =0 {선택한 항목 없음} one {#개 항목 선택됨} other {#개 항목 선택됨}}",
  "sidepanel.collapse": "사이드 패널 축소",
  "sidepanel.expand": "사이드 패널 확장",
  "slider.maximum": "최대",
  "slider.minimum": "최소",
  "table.cancel": "취소",
  "table.drag": "드래그",
  "table.editCell": "셀 편집",
  "table.loading": "로드 중…",
  "table.loadingMore": "추가 로드 중…",
  "table.resizeColumn": "열 크기 조정",
  "table.save": "저장",
  "table.sortAscending": "오름차순 정렬",
  "table.sortDescending": "내림차순 정렬",
  "tag.actions": "액션",
  "tag.hideButtonLabel": "간략히 보기",
  "tag.noTags": "없음",
  "tag.showAllButtonLabel": "모두 표시 ({tagCount, number})",
  "toast.clearAll": "모두 지우기",
  "toast.collapse": "접기",
  "toast.showAll": "모두 표시",
  "treeview.loadingMore": "추가 로드 중…"
}
